/* eslint-disable unicorn/filename-case */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import React, { useCallback, useEffect, useMemo, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { appendMetadataWithIndex, readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { AddressStandardizationComponent, AdditionalInterestComponent } from "premier-capability-policyjob-react";
import DriverAssignmentComponent from 'premier-capability-policyjob-react/components/DriverAssignmentComponent/DriverAssignmentComponent';
import { useUpdateSubmissionServices } from 'premier-capability-hooks';
import { useTranslator } from '@jutro/locale';
import MarketAccessoryComponent from '../MarketAccessoryComponent/MarketAccessoryComponent'
import SafetyEquipmentComponent from '../SafetyEquipmentComponent/SafetyEquipmentComponent'
import CoveragesPageComponent from '../../pages/Coverages/CoveragesPage';
import metadata from './RVVehicleComponent.metadata.json5';
import styles from './RVVehicleComponent.module.scss';
import './RVVehicleComponent.messages';

function RVVehicleComponent(props) {
    const {
        data: vehicleVM,
        submissionVM,
        phoneWide,
        labelPosition,
        path,
        id,
        index,
        onValidate,
        onValueChange,
        updateWizardData,
        authHeader
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const { onValidate: setComponentValidation, isComponentValid, registerComponentValidation } = useValidation(id);
    const [isAddLocation, setIsAddLocation] = useState(false);
    const [isEditLocation, setIsEditLocation] = useState(false);
    const [locationVM, setLocationVM] = useState({});
    const [garageLocations, setGarageLocations] = useState([]);
    const { updateSubmission } = useUpdateSubmissionServices();
    const [isLoading, setLoading] = useState(false);
    let offeringType;
    let selectedOffering;
    const translator = useTranslator();
    const formattedMetadata = useMemo(() => appendMetadataWithIndex(metadata.pageContent, index), [index]);
    const areChildComponentsValid = useCallback(() => {
        const safetyEquipmentsVM = vehicleVM.safetyEquipments
        const afterMarketAccessoryVM = vehicleVM.afterMarketAccessories
        const driverAssignmentVM = vehicleVM.assRisks
        let isSafetyEqpAdded;
        let isMarketAccAdded;
        let isDriverAssigned;
        if (safetyEquipmentsVM){
            isSafetyEqpAdded = safetyEquipmentsVM.aspects.valid && safetyEquipmentsVM.aspects.subtreeValid;
        }
        if (afterMarketAccessoryVM){
            isMarketAccAdded = afterMarketAccessoryVM.aspects.valid && afterMarketAccessoryVM.aspects.subtreeValid;
        }
        if (driverAssignmentVM) {
            isDriverAssigned = driverAssignmentVM.aspects.valid && driverAssignmentVM.aspects.subtreeValid;
        }
        if(isSafetyEqpAdded && isMarketAccAdded && isDriverAssigned && !_.find(_.get(vehicleVM.value,'clausesGroups.coverages'), { isValid: false })){
            return true;
        }
        return false;

    }, [vehicleVM.safetyEquipments, vehicleVM.afterMarketAccessories, vehicleVM.assRisks, vehicleVM.value]);

    const getIsFormValid = useCallback(() => vehicleVM.aspects.subtreeValid && vehicleVM.aspects.valid, [vehicleVM]);

    useEffect(() => {
        registerComponentValidation(getIsFormValid);
        registerComponentValidation(areChildComponentsValid);
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
        const policyLocations = submissionVM ? submissionVM.baseData.policyLocations_Ext.value.map((loc) => {
            const location = loc;
            location.id = location.accountLocPublicID; 
            location.displayName = location.locationName || location.address.displayName
            return location; 
        }) : [];
        setGarageLocations(policyLocations);
    }, [id, onValidate, isComponentValid, vehicleVM, submissionVM, index, registerComponentValidation, areChildComponentsValid, getIsFormValid]);

    const handleFormDetailsChange = (value, changedPath, submissionPath) => {
        if(changedPath === 'basisOfSettlement' && value === 'ActCasVal') {
            _.set(submissionVM, `${submissionPath}.programType.value`, 'Sta');
            _.set(submissionVM, `${submissionPath}.policyForm.value`, 'NamPer');
        } else if(changedPath === 'basisOfSettlement' && value === 'RepCos') {
            _.set(submissionVM, `${submissionPath}.programType.value`, 'ChoAllRis');
            _.set(submissionVM, `${submissionPath}.policyForm.value`, 'AllRis');
        } else if(changedPath === 'basisOfSettlement' && value === 'GuaRepCos') {
            _.set(submissionVM, `${submissionPath}.programType.value`, '');
            _.set(submissionVM, `${submissionPath}.policyForm.value`, '');
        }
    }

    const handleBlur = () => {
          if(vehicleVM.aspects.subtreeValid){
                updateVehicleInformation()
            }
    };

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${path}.${changedPath}`;
            handleFormDetailsChange(value, changedPath, path);
            if (onValueChange) {
                onValueChange(value, fullPath);
            }
        }, 
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [onValueChange, path, vehicleVM.aspects.subtreeValid]
    );

    const onCreateorUpdateLocation = async () => {
        const quoteID = _.get(submissionVM, 'quoteID.value');
        const updatedLocation = await LoadSaveService.createOrUpdatePolicyLocation([quoteID, locationVM.value, null], authHeader);
        if(isAddLocation) {
            _.set(vehicleVM, 'garagedAt.value', updatedLocation.accountLocPublicID);
            locationVM.publicID.value = updatedLocation.publicID;
            locationVM.displayName.value = updatedLocation.displayName;
            locationVM.accountLocPublicID.value = updatedLocation.accountLocPublicID;
            submissionVM.baseData.policyLocations_Ext.value.push(locationVM.value)
        } else {
            const editedLocation = submissionVM.baseData.policyLocations_Ext.children.filter((loc) => loc.value.publicID === locationVM.value.publicID)[0]
            editedLocation.value = locationVM.value;
            editedLocation.displayName.value = updatedLocation.displayName;
        }
        const newSubmissionVM = viewModelService.clone(submissionVM);
        updateWizardData(newSubmissionVM);
        const policyLocations = submissionVM ? newSubmissionVM.baseData.policyLocations_Ext.value.map((loc) => {
            const location = loc;
            location.id = location.accountLocPublicID; 
            return location; 
        }) : [];
        setGarageLocations(policyLocations);
        setIsAddLocation(false);
        setIsEditLocation(false);
    };

    const createLocationVM = (model) => {

        const { _xCenter, _dtoName } = submissionVM.baseData.policyLocations_Ext;
        const newLocationVM = viewModelService.create(model, _xCenter, _dtoName);
        return newLocationVM;
    };

    const handleAddNewLocation = () => {
        const model = { country: 'CA', state: 'ON' };
        setLocationVM(createLocationVM(model));
        setIsAddLocation(true);
        setIsEditLocation(false);

    };

    const handleEditNewLocation = () => {
        const selectedLocation = _.get(vehicleVM, 'garagedAt.value');
        const model = submissionVM.baseData.accountLocPublicIDions_Ext.value.filter((l) => l.accountLocPublicID === selectedLocation)[0];
        setLocationVM(createLocationVM(model));
        setIsAddLocation(false);
        setIsEditLocation(true);
    };

    const cancelLocation = async () => {
        setIsAddLocation(false);
        setIsEditLocation(false);
    };

    const OnAddressValueChange = (value, changedPath) => {
        const newLocationVM = viewModelService.clone(locationVM);
        if(changedPath){
            _.set(newLocationVM, changedPath, value);
        } else {
            newLocationVM.value = value
        }       
        setLocationVM(newLocationVM);
    }

    const handleAddSafetyEquipment = useCallback(
        (safetyRecordVM) => {
            vehicleVM.safetyEquipments.pushElement(safetyRecordVM);
            _.set(submissionVM, path, vehicleVM.value);
           const newSubmissionVMClone = viewModelService.clone(submissionVM);
           updateWizardData(newSubmissionVMClone);
        },
        [vehicleVM.safetyEquipments, vehicleVM.value, submissionVM, path, viewModelService, updateWizardData]
    ); 


    const updateVehicleInformation = useCallback(
        async () => {
            setLoading(true)
          const response = await updateSubmission('', '', submissionVM, undefined);
            submissionVM.lobData.recVehLine.coverables.vehLocRisks.value = response.lobData.recVehLine.coverables.vehLocRisks
            updateWizardData(submissionVM);
            setLoading(false)
        },
        [submissionVM, updateSubmission, updateWizardData]
    ); 

    const handleAddMarketAccessory = useCallback(
        (accessoryRecordVM) => {
            vehicleVM.afterMarketAccessories.pushElement(accessoryRecordVM);
            _.set(submissionVM, path, vehicleVM.value);
           const newSubmissionVMClone = viewModelService.clone(submissionVM);
           updateWizardData(newSubmissionVMClone);
        },
        [vehicleVM.afterMarketAccessories, vehicleVM.value, submissionVM, path, viewModelService, updateWizardData]
    );

    const handleComponentValueChange = useCallback(
        (value, changedPath) => {
            _.set(vehicleVM, changedPath, value);
           const newSubmissionVMClone = viewModelService.clone(submissionVM);
           updateWizardData(newSubmissionVMClone);
        },
        [vehicleVM, viewModelService, submissionVM, updateWizardData]
    );

    const getPrimaryUsage = () =>{

        if(vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === "MotCyc"){
            offeringType = 'motorccycle'
        }
        else if(vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === "OffRoaVeh"){
            offeringType = 'offroad'
        }
        else {
            offeringType = 'vacationtrailer'
        }
        const primaryUsageFilter = _.find(vehicleVM.primaryUse.aspects.availableValues[0].typelist.filters, {
            name: offeringType
          })

        return primaryUsageFilter.codes.map((key) => ({
            code: key.code,
                name: translator({
                    id: key.name,
                    defaultMessage: key.name
                })
        }));

};

     const getVehicleType = () =>{

        if(vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === "MotCyc"){
            selectedOffering = 'MotrCyclTyp'
        }
        else if(vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === "OffRoaVeh"){
            selectedOffering = 'OffRoadTyp'
        }
        else {
            selectedOffering ='VacTraVehTyp'
        }
        const vehicleTypes = _.find(vehicleVM.vehicleType.aspects.availableValues[0].typelist.filters, {
            name: selectedOffering
          })

        return vehicleTypes.codes.map((key) => ({
            code: key.code,
                name: translator({
                    id: key.name,
                    defaultMessage: key.name
                })
        }));

};
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true,
            labelPosition,
            phoneWide,
            onBlur: handleBlur,
        },
       [`addressLookupComponent${index}`]: {
            visible: isAddLocation || isEditLocation,
            model: locationVM,
            onValueChange: OnAddressValueChange,
            viewModelService,
            labelPosition: 'left'
        },
        [`editNewLocationButton${index}`]: {
            onClick: handleEditNewLocation,
            disabled: (isAddLocation || isEditLocation || !(_.get(vehicleVM, 'garagedAt.value')))
        },
        [`addNewLocationButton${index}`]: {
            onClick: handleAddNewLocation,
            disabled: isAddLocation || isEditLocation
        },
        [`addAddressButton${index}`]: {
            onClick: onCreateorUpdateLocation,
            visible: isAddLocation
        },
        [`saveAddressButton${index}`]: {
            onClick: onCreateorUpdateLocation,
            visible: isEditLocation
        },
        [`cancelAddressButton${index}`]: {
            onClick: cancelLocation,
            visible: (isAddLocation || isEditLocation)
        },
        [`garagedAt${index}`]:{
            availableValues: garageLocations
        },
        [`rvSafetyEquipmentComponent${index}`]:{
            value: vehicleVM.safetyEquipments || [],
            path:  `lobData.recVehLine.coverables.vehLocRisks.children.${index}.safetyEquipments`,
            index,
            onValueChange : handleComponentValueChange,
            onValidate,
            handleAddSafetyEquipment
        }, 
        [`rvMarketAccessoryComponentMot${index}`]:{
            value: vehicleVM.afterMarketAccessories || [],
            path:  `lobData.recVehLine.coverables.vehLocRisks.children.${index}.afterMarketAccessories`,
            index,
            onValueChange : handleComponentValueChange,
            onValidate,
            handleAddMarketAccessory,
            visible: vehicleVM.offering_Ext && (vehicleVM.offering_Ext.value  === "MotCyc")
        },
        [`rvMarketAccessoryComponent${index}`]:{
            visible: false
        }, 
        [`rvLineCoverageComponent${index}`] : {
            wizardData: submissionVM,
            updateWizardData,
            index,
            clausesBasePath: `lobData.recVehLine.coverables.vehLocRisks.${index}.clausesGroups`,
            vehicleVM
        },
       [`additionalInterest${index}`]:{
            value: submissionVM,
            path: `lobData.recVehLine.coverables.vehLocRisks.children.${index}.additionalInterests`,
            type: 'additionalInterest',
            onValueChange: updateWizardData,
            authHeader
        }, 
        [`val${index}`]:{
            visible: vehicleVM.offering_Ext && (vehicleVM.offering_Ext.value  === "MotCyc")
        },
        [`engSiz${index}`]:{
            visible: vehicleVM.offering_Ext && (vehicleVM.offering_Ext.value  === "MotCyc" || vehicleVM.offering_Ext.value  === 'OffRoaVeh')
        },
        [`bikeClass${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === "MotCyc"
        },
        [`year${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  !== 'MotCyc'
        },
        [`vehicleYear${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc',
            required: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc',
        },
        [`manufacturer${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra'
        },
        [`model${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra'
        },
        [`isTheUnitOwnByOrgOwn${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra'
        },
        [`isUniUseAsPerRes${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra'
        },
        [`opeOutProCou${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'OffRoaVeh'
        },
        [`stoDurOffSea${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'OffRoaVeh'
        },
        [`stoDurRidSea${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'OffRoaVeh'
        },
        [`newUse${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  !== 'VacTra'
        },
        [`lisPri${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  !== 'VacTra'
        },
        [`numOfTimesUSedPerMonth${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
        },
        [`isVehReg${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'OffRoaVeh'
        },
        [`storageContainer${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
        },
        [`otherVehicleInfoContainer${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra'
        },
        [`formDetails${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra'
        },
        [`trailerDetails${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'OffRoaVeh'
        },
        [`serialVin${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'OffRoaVeh'
        },
        [`imm${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'OffRoaVeh'
        }, 
        [`purPri${index}`]: {
            visible: vehicleVM.offering_Ext.value === 'VacTra' ||
                (vehicleVM.offering_Ext.value === 'MotCyc' && (vehicleVM.newUse?.value?.code === 'New' || vehicleVM.newUse?.value?.code === 'demo'))
        },
        [`DriverAssignment${index}`]: {
            data:vehicleVM.assRisks,
            onValidate,
            updateWizardData,
            submissionVM,
            vehcileDriverPath: `lobData.recVehLine.coverables.vehLocRisks.children.${index}.assRisks`,
            index,
            visible: false
        },
        [`driverAssignmentMot${index}`]: {
            data:vehicleVM.assRisks,
            onValidate,
            updateWizardData,
            submissionVM,
            vehcileDriverPath: `lobData.recVehLine.coverables.vehLocRisks.children.${index}.assRisks`,
            index,
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
        },
        [`safetyContainer${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value !== 'VacTra'
        },
        [`accessoriesContainer${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value !== 'VacTra'
        },
        [`vehiclePageLoader${index}`]: {
            visible: isLoading
        }, 
        [`vehLocRiskDetailsPageContainer${index}`]: {
            visible: !isLoading
        },
        [`priUse${index}`]:{
            required:true,
            availableValues:getPrimaryUsage()
        },
        [`ifOthPleExpMot${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
                && vehicleVM.primaryUse && vehicleVM.primaryUse.value.code === 'Other'
        },
        [`vehTyp${index}`]:{
            required:true,
            availableValues:getVehicleType()
        },
        [`primaryUsageContainer${index}`]: {
            visible:vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  !== 'VacTra'
        },
        [`ifOthPleExpMot${index}`]: {
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value === 'MotCyc'
                && _.get(vehicleVM.value, 'primaryUse') === 'Other'
        }, 
        [`ifOthPleExp${index}`]: {
            visible:vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra' && vehicleVM.rooMat.value && vehicleVM.rooMat.value.code === 'Oth' ? true : false
        },
        [`rooMaterial${index}`]: {
            visible:vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra'
        },
        [`ifOthExp${index}`]: {
            visible:(vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'VacTra') && (!_.isUndefined(vehicleVM.rooMat.value) && vehicleVM.rooMat.value.code === 'Oth')
        },
        [`trailerDetailsContainer${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
        },
        [`vin${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  !== 'MotCyc'
        },
        [`vinMot${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
        },
        [`ownershipType${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  !== 'MotCyc'
        },
        [`ownershipTypeMot${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
        },
        [`vehicleMileageContainer${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
        },
        [`accessoriesContainer${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  !== 'MotCyc'
        },
        [`accessoriesContainerMot${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value  === 'MotCyc'
        },   
        [`val${index}`]:{
            visible: vehicleVM.offering_Ext.value  === 'MotCyc' && !_.isUndefined(vehicleVM.value.newUse) && vehicleVM.value.newUse === 'Used'
        },
        [`vehicleMake${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value === 'MotCyc'
        },
        [`rateEffDate${index}`]:{
            visible: vehicleVM.offering_Ext && vehicleVM.offering_Ext.value === 'MotCyc'
        },
              
    }

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            addressStandardizationComponent: AddressStandardizationComponent,
            additionalInterestComponent: AdditionalInterestComponent,
            marketAccessoryComponent : MarketAccessoryComponent,
            safetyEquipmentComponent : SafetyEquipmentComponent,
            coveragespagecomponent: CoveragesPageComponent,
            DriverAssignmentComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            formattedMetadata,
            vehicleVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [vehicleVM, formattedMetadata, overrideProps]
    );

    return (
        <ViewModelForm
            model={vehicleVM}
            uiProps={formattedMetadata}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValidationChange={setComponentValidation}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

RVVehicleComponent.propTypes = {
    data: PropTypes.shape({}),
    phoneWide: PropTypes.shape({}),
    labelPosition: PropTypes.string,
    path: PropTypes.string,
    onValueChange: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    readOnlyFields: PropTypes.arrayOf(PropTypes.string),
    showOptional: PropTypes.bool,
    index: PropTypes.string,
    id: PropTypes.string.isRequired
};
RVVehicleComponent.defaultProps = {
    data: {},
    labelPosition: 'left',
    phoneWide: {
        labelPosition: 'top'
    },
    path: undefined,
    readOnlyFields: [],
    showOptional: true,
    index: 0
};
export default RVVehicleComponent;